import { useCallback, useContext } from 'react';

import type {
  ProductCategory,
  Variation,
} from 'src/modules/designStudio/helpers/productSelection/types';
import { productCatalogContext } from 'src/modules/designStudio/providers';

export const useSearchForVariationsByUUID = () => {
  const { pcDataStore } = useContext(productCatalogContext);

  const getVariationsByUUIDs: (
    ids: string[],
    category: ProductCategory,
  ) => Variation[] = useCallback(
    (ids: string[], category): Variation[] => {
      if (!pcDataStore) {
        return [];
      }
      return ids
        .map(id => pcDataStore.getVariationByUUID(id, category))
        .filter(v => !!v);
    },
    [pcDataStore],
  );

  return getVariationsByUUIDs;
};
